import React, { useState, useEffect } from 'react'
import { Button, Container, Col, Form, Row, Spinner,Table, Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import ReactExport from 'react-export-excel';
import toastr from 'toastr';
import moment from 'moment';

import CustomNavbar from '../../components/CustomNavbar';
//import SidebarDashboard from '../../components/SidebarDashboard';
import CustomTable from '../../components/CustomTable';
import CustomPagination from '../../components/CustomPagination';
import { getReporteLogin, getReporteLoginExcel } from '../../redux/reporteLogin/actions';

import SidebarConfig from '../../components/SidebarConfig';

import ExcelIcon from '../../images/icons8-microsoft-excel.svg'

const LoginReport = () => {
  //Excel
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
  //Fin Excel

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [inicio, setInicio] = useState(moment().startOf('month').subtract(1, 'month').format('yyyy-MM-DD'));
  const [fin, setFin] = useState(moment().startOf('month').subtract(1, 'month').format('yyyy-MM-DD'));
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();

  const data = useSelector(store => store.reporteLogin.reporteLogin);
  const dataLength = useSelector(store => store.reporteLogin.reporteLoginLength);
  const pages = Math.ceil(dataLength / limit);
  const loading = useSelector(store => store.reporteLogin.loading);

  const dataExcel = useSelector(store => store.reporteLogin.reporteLoginExcel);
  const loadingExcel = useSelector(store => store.reporteLogin.loadingExcel);

  // Métodos
  useEffect(() => {
    dispatch(getReporteLogin({
      inicio: inicio,
      fin: fin,
      offset: offset,
      limit: limit
    }));
    dispatch(getReporteLoginExcel({
      inicio: inicio,
      fin: fin
    }));
  }, [dispatch, inicio, fin, offset, limit]);

  /*Paginación*/
  const prev = () => {
    if(currentPage <= 0)
      setCurrentPage(0);
    else
      setCurrentPage(currentPage - 1);

    setOffset(offset - limit);
  }

  const next = () => {
    if (currentPage >= pages)
      setCurrentPage(pages);
    else
      setCurrentPage(currentPage + 1);
    
    setOffset(offset + limit);
  }

  const last = () => {
    setCurrentPage(pages);
    setOffset((pages * limit) - limit);
  }

  const first = () => {
    setCurrentPage(1);
    setOffset(0);
  }

  const onChangeLimit = value => {
    setLimit(parseInt(value));
    setOffset(0);
    setCurrentPage(1);
  };
  /*fin paginación*/

  const seeData = e => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    
    if (moment(e.target.fecha_min.value) > moment(e.target.fecha_max.value)){
      toastr.error('La fecha inicial no pueder ser mayor a la fecha final');
    } else {
      setInicio(moment(e.target.fecha_min.value).format('yyyy-MM-DD'));
      setFin(moment(e.target.fecha_max.value).format('yyyy-MM-DD'));
    }
  }
  
  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={'dashboard'} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            {/* <h6 className="font-weight-bold text-uppercase">Inicios de sesión</h6> */}
            <h6 className="font-weight-bold text-uppercase">Informe de inicios de sesión</h6>
            {
              loadingExcel ? (
                <div className="d-flex justify-content-center">
                  <Spinner 
                    animation="border" 
                    role="status" 
                    className="d-flex justify-content-center" />
                </div>
              ) : (
              <ExcelFile element={<Button disabled={dataExcel && dataExcel.length === 0} variant="primary" size="sm"><img src={ExcelIcon}></img>Exportar</Button>}>
                {
                  dataExcel && (
                    <ExcelSheet data={dataExcel} name="Reporte Inicios de Sesión">
                      <ExcelColumn label="Usuario" value="codigo" />
                      <ExcelColumn label="Nombre" value="nombre" />
                      <ExcelColumn label="Correo Empresarial" value="correo" />
                      <ExcelColumn label="Fecha Inicial" value="fecha_creacion" />
                      <ExcelColumn label="Fecha Final" value={(col) => col.ultimo_acceso?moment(col.ultimo_acceso).format('yyyy-MM-DD'):null} />
                    </ExcelSheet>
                  )
                }
              </ExcelFile>
              )
            }
          </div>
          <div className="px-2">
            <hr />
          </div>
          <Row className="mb-3">
            <Col sm={12}>
              <Row className="align-items-end">
                <Col sm={12} className="mt-2">
                  <Form 
                    onSubmit={seeData} noValidate validated={validated}
                  >
                    <Form.Group>
                      <Form.Label className="ml-2">Fecha:</Form.Label>
                      <Row>
                        <Col sm={4}>
                          <Form.Control
                            name="fecha_min"
                            className="rounded-pill"
                            required
                            type="date"
                            defaultValue={inicio}
                            placeholder="fecha inicial"></Form.Control>
                          <Form.Control.Feedback type="invalid">
                            **Este campo es requerido
                          </Form.Control.Feedback>
                        </Col>
                        <Col sm={4}>
                          <Form.Control
                            name="fecha_max"
                            className="rounded-pill"
                            required
                            type="date"
                            defaultValue={fin}
                            placeholder="fecha final"></Form.Control>
                          <Form.Control.Feedback type="invalid">
                            **Este campo es requerido
                          </Form.Control.Feedback>
                        </Col>
                        <Col sm={4}>
                          <Button
                            type="submit"
                            variant="primary"
                            size="md"
                            block
                          ><b>Filtrar datos</b></Button>
                        </Col>
                      </Row>
                    </Form.Group>
                  </Form>

                </Col>
              </Row>

            </Col>

          </Row>
          {
            loading ? (
              <div className="d-flex justify-content-center">
                <Spinner 
                  animation="border" 
                  role="status" 
                  className="d-flex justify-content-center" />
              </div>
            ) : data.length>0 && (
              <Table striped>
                <thead>
                  <tr>
                    <th>Usuario</th>
                    <th>Nombre</th>
                    <th>Correo Empresarial</th>
                    <th>Fecha Inicial</th>
                    <th>Fecha Final</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    data.map(item => (
                      <tr>
                        <td>{item.codigo}</td>
                        <td>{item.nombre}</td>
                        <td>{item.correo}</td>
                        <td>{item.fecha_creacion}</td>
                        <td>{item.ultimo_acceso?moment(item.ultimo_acceso).format('yyyy-MM-DD'):null}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            )
          }
          {data.length>0 && 
          <CustomPagination 
            limit={limit}
            offset={offset}
            currentPage={currentPage}
            dataLenght={dataLength}
            pages={pages}
            prev={ prev }
            next={ next }
            first={ first }
            last={ last }
            onChangeLimit={onChangeLimit} 
          />
          }
          {
            data.length === 0 && (
              <Alert variant="info" className="my-4">
                No hay inicios de sesión en las fechas establecidas
              </Alert>
            )
          }
        </Container>
      </div>
    </>
  )
}

export default LoginReport